import {inject, Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';
import {Moment} from 'moment';
import {TimezoneService} from 'src/app/services/timezone.service';

@Pipe({name: 'dayAbbreviation'})
export class DayAbbreviationPipe implements PipeTransform {
  private timezoneService = inject(TimezoneService);

  transform(date: Date | Moment | string): string {
    if (!date) {
      return '';
    }

    const momentDate = moment(date).tz(this.timezoneService.getTimeZone());
    const dayOfWeek = (momentDate.day() + 6) % 7;

    switch (dayOfWeek) {
      // Entire app is configured to use Monday as the first day of the week
      case 0:
        return 'M';
      case 1:
        return 'Tu';
      case 2:
        return 'W';
      case 3:
        return 'Th';
      case 4:
        return 'F';
      case 5:
        return 'Sa';
      case 6:
        return 'Su';
      default:
        return '';
    }
  }
}
